import {AxiosError} from 'axios'
import {get, post} from 'utils/axios'
import {handleRejectedErrorMsg} from 'utils/helpers/handleError'

import {
 NotificationResponse,
 RegisterFcmRequest,
 RegisterFcmResponse,
 MarkReadRequest,
 MarkReadResponse,
 NotificationListResponse,
} from 'models/Notification'

interface GetNotificationParams {
 app_id: string
 status?: 'all' | 'read' | 'unread'
 days?: number
 page?: number
 page_size?: number
}

const registerFcmTokenApi = async (
 payload: RegisterFcmRequest
): Promise<{
 data: RegisterFcmResponse['data'] | null
}> => {
 try {
  const res = await post<RegisterFcmResponse>(
   '/notifications/v1/push/devices/',
   {...payload, app_code: 'web'}
  )

  if (res?.success) {
   return {data: res.data}
  }

  return {data: null}
 } catch (err) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)

  return {data: null}
 }
}

const getNotificationsApi = async (
 params: GetNotificationParams
): Promise<NotificationListResponse | null> => {
 try {
  const query = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
   if (value !== undefined && value !== null) {
    query.append(key, String(value))
   }
  })

  const res = await get<NotificationResponse>(
   `/notifications/v1/in-app/?${query.toString()}`,
   {app_code: 'web'}
  )

  if (res?.success) {
   return res.data
  }

  return null
 } catch (err) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)

  return null
 }
}

const markNotificationReadApi = async (
 payload: MarkReadRequest
): Promise<boolean> => {
 try {
  const res = await post<MarkReadResponse>(
   '/notifications/v1/in-app/mark-read/',
   {...payload}
  )

  if (res?.success) {
   return true
  }

  return false
 } catch (err) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)

  return false
 }
}

export {
 registerFcmTokenApi,
 getNotificationsApi,
 markNotificationReadApi,
}
